<a nz-popconfirm [nzPopconfirmTitle]="title" nzOkText="确认" nzCancelText="取消" (nzOnConfirm)="confirm.emit()"
    nzPopconfirmPlacement="bottom">
    <button nzType="link" nz-button nzTooltipTitle="关闭" nz-tooltip  nzTooltipPlacement="topLeft">
        <i nz-icon nzType="close" ></i>
    </button>
</a>